/*! @azure/msal-browser v2.15.0 2021-06-29 */
'use strict';
/* eslint-disable header/header */

var name = "@azure/msal-browser";
var version = "2.15.0";
export { name, version };